import React from 'react';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Flex } from 'reflexbox';
import PageHeader from '../components/gamePlayComponents/PageHeader';
import { PRIMARYCOLOR } from '../components/helpers/ThemeSettings';

const cardContent = [
  {
    headline: 'Look around—no studying required.',
    body: 'Everything is based on observation. You don’t need trivia knowledge or to have read up beforehand. If you can see it, you can use it.',
  },
  {
    headline: 'Some are quick wins. Some are head-scratchers.',
    body: 'Questions range from “got it!” to “hmm, let’s figure this out.” Talk it over, look again, and take your time. Think of it like an outdoor escape room.',
  },
  {
    headline: 'Hints and skips are there for a reason.',
    body: 'Using hints is totally okay. So is skipping. We want you to have fun, not stress. Use whatever helps you enjoy the experience.',
  },
  {
    headline: 'We’ll fill you in as you go.',
    body: 'After each question we’ll share some facts and context. You’ll learn as you play—no prep needed.',
  },
  {
    headline: 'Finish strong and climb the leaderboard.',
    body: 'At the end, your total score will be ranked against other teams—and the highest scores earn a spot on the leaderboard.',
  },
];

const WhatToExpect = () => {
  return (
    <>
      <PageHeader goBack title="What to Expect" />
      <Flex
        flexDirection="column"
        style={{
          padding: '0 16px 24px',
          gap: '16px',
          maxWidth: '480px',
          margin: '0 auto',
        }}
      >
        {cardContent.map((card, index) => (
          <Card
            key={index}
            elevation={0}
            sx={{
              borderRadius: '16px',
              border: `2px solid ${PRIMARYCOLOR}`,
              bgcolor: 'background.paper',
              overflow: 'hidden',
            }}
          >
            <CardContent style={{ padding: '20px' }}>
              <Typography
                variant="h6"
                component="h2"
                style={{
                  color: PRIMARYCOLOR,
                  fontWeight: 600,
                  marginBottom: '12px',
                  fontSize: '1.1rem',
                }}
              >
                {card.headline}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: 'text.primary',
                  lineHeight: 1.5,
                  fontSize: '1rem',
                }}
              >
                {card.body}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </Flex>
    </>
  );
};

export default WhatToExpect;
